import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bf35d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promocode__legal-text" }, [
  /*#__PURE__*/_createTextVNode(" Реклама, предложение действует с 11.07.2023 по 01.07.2024, полные правила акции уточняйте в "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://terms.samokat.ru/promo/Pravila_Leto_vpechatleniy.pdf",
    target: "_blank"
  }, "условиях акции"),
  /*#__PURE__*/_createTextVNode(". Продавец ООО «Умный ритейл», ОГРН 1177847261602, 192019, Санкт-Петербург, ул.Седова, дом.11, Литер А, Этаж 6, помещение 627. ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promocode__legal-text" }, [
  /*#__PURE__*/_createTextVNode(" Сделано в "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://groznov.co",
    target: "_blank"
  }, "GROZNOV"),
  /*#__PURE__*/_createTextVNode("® ")
], -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ "white-link": _ctx.whiteLink })
  }, _hoisted_3, 2))
}